import { can } from './utils/rights';

export default {
  links() {
    return [
    ];
  },

  settings() {
    return [
      {
        to: '/users',
        icon: 'mdi-account-supervisor',
        label: this.$t('menu.settings.subMenu.users'),
        hidden: async () => !(await can('user', 'read')),
      },
      {
        to: '/roles',
        icon: 'mdi-security',
        label: this.$t('menu.settings.subMenu.roles'),
        hidden: async () => !(await can('role', 'read')),
      },
    ];
  }
};
